import { MMButton } from '@components'
import ToastClose from '@images/icons/close-toast-icon.svg?react'
import ToastError from '@images/icons/error-toaster-icon.svg?react'
import ToastSuccess from '@images/icons/success-toaster-icon.svg?react'
import type { ReactNode } from 'react'
import { ToastBar, Toaster, type ToastOptions, toast } from 'react-hot-toast'

import './coreToaster.scss'

export const TOAST_DEFAULT_DURATION = 3_000

const TOAST_BASE_STYLE = {
  maxWidth: 'none',
  borderRadius: '3.6rem',
  boxShadow: '0 2px 8px 0 rgba(30, 41, 59, 0.12)',
  height: 'auto',
  padding: '1px 8px'
}

export const TOAST_SUCCESS_OPTIONS: ToastOptions = {
  className: 'toast-success-wrapper',
  style: TOAST_BASE_STYLE,
  icon: <ToastSuccess />
}

export const TOAST_ERROR_OPTIONS: ToastOptions = {
  className: 'toast-error-wrapper',
  style: TOAST_BASE_STYLE,
  icon: <ToastError />
}

export function CoreToaster(): ReactNode {
  return (
    <Toaster
      gutter={10}
      position='top-right'
      containerStyle={{
        top: '10rem',
        zIndex: '10010'
      }}
      toastOptions={{
        duration: TOAST_DEFAULT_DURATION,
        success: TOAST_SUCCESS_OPTIONS,
        error: TOAST_ERROR_OPTIONS
      }}
    >
      {t => {
        return (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <div className='toast-content-wrapper'>
                <div className='content'>
                  {icon}
                  <span className='caption'>{message}</span>
                </div>
                <MMButton
                  type='button'
                  size='normal'
                  variant='tertiary'
                  collapsed
                  collapsedIcon={ToastClose}
                  onClick={() => toast.dismiss(t.id)}
                  style={{
                    backgroundColor: 'white'
                  }}
                />
              </div>
            )}
          </ToastBar>
        )
      }}
    </Toaster>
  )
}
